import axios from 'axios'
import router from '@/router/index.js'
import { Message } from 'element-ui'
import { humpObjectDeep } from '@/utils/common'

let needLoadingRequestCount = 0
/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  // 记录当前路径 方便登录后可以重返该路径
  const path = router.currentRoute.fullPath

  router.replace({
    path: '/login',
    query: {
      redirect: path
    }
  })
}
const toHome = () => {
  router.replace({
    path: '/home'
  })
}

// 请求提示函数 brian
const TipMessage = (code, msg) => {
  // 处理多次提示
  if (needLoadingRequestCount === 1 || needLoadingRequestCount === 0) {
    // 后端给的请求提示code
    switch (code) {
      case 500000: {
        Message({
          type: 'error',
          message:
            msg || $t('integration.normal_request_response_c__but_failed')
        })
        break
      }
      case 500087: {
        Message({
          type: 'error',
          message: $t('integration.the_account_does_not_exist')
        })
        break
      }
      case 500088: {
        Message({
          type: 'error',
          message: $t('integration.password_error')
        })
        break
      }
      case 500100: {
        Message.closeAll()

        Message({
          type: 'error',
          message: $t(
            'integration.login_credential_expired_c__please_login_again'
          )
        })
        toLogin()
        break
      }
      case 500102: {
        Message({
          type: 'error',
          message: $t(
            'integration.no_permission_c__please_contact_the_administrator'
          )
        })
        break
      }
      case 500103: {
        Message({
          type: 'error',
          message: $t('integration.login_failed')
        })
        break
      }
      case 500104: {
        Message({
          type: 'error',
          message: $t('integration.login_conflict')
        })
        toLogin()
        break
      }
      case 500105: {
        Message({
          type: 'error',
          message: $t('integration.do_not_log_in_again')
        })
        toHome()
        break
      }
      case 50098: {
        Message({
          type: 'error',
          message: $t('integration.login_failed')
        })
        break
      }
      case 'error': {
        Message({
          type: 'error',
          message: $t(
            'integration.server_error_c__request_failed_c__please_contact_management'
          )
        })
        break
      }
      case 500: {
        Message({
          type: 'error',
          message: msg || $t('integration.server_error_c__request_failed_c__please_contact_management')
        })
        break
      }
      default:
        break
    }
  }
}
// 请求失败提示
const tip = msg => {
  Message({
    message: msg,
    duration: 1000,
    type: 'error'
  })
}
/**
 * 请求失败后的错误统一处理 author:brian
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  switch (status) {
    // 401: 未登录状态，跳转登录页
    case 400:
      tip($t('integration.parameter_error'))
      break
    case 401:
      toLogin()
      break

    case 403:
      tip($t('integration.login_expired_c__please_login_again'))
      setTimeout(() => {
        toLogin()
      }, 1000)
      break
    // 404请求不存在
    case 404:
      tip($t('integration.the_requested_resource_does_not_exist'))
      break
    case 405:
      toLogin()
      break
    case 500:
      tip($t('integration.server_error_c__please_contact_administrator'))
      toLogin()
      break
    default:
      tip(other)
  }
}
// create asios 实例
const instance = axios.create({
  // url = base url + request url
  // VUE_APP_BASE_API takes priority; falls back to VUE_APP_PUBLIC_PATH so that
  // sub-path deployments (preview envs) prefix API calls with /<branch>/.
  baseURL: process.env.VUE_APP_BASE_API || process.env.VUE_APP_PUBLIC_PATH || '',
  timeout: 10000
})

// 根据当前请求信息生成key  key值用于判断是否重复请求
// function generateReqKey(config){
//   // 如果请求方法 url 参数都一致， 基本上就可以断定是同一个请求
//   const {method,url,params,data} = config;
//   return [method,url,qs.stringify(params),qs.stringify(data)].join("&");
// }

// // 在pending状态中的请求 键名对应其取消令牌
// const pendingRequest = new Map();

// function addPendingRequest(config){
//   const requestKey = generateReqKey(config);
//   config.cancelToken = config.cancelToken || new axios.CancelToken((cancel)=>{
//     // pending的请求中未找到这个请求 则给其添加一个cancelToken
//     if(!pendingRequest.has(requestKey)){
//       pendingRequest.set(requestKey,cancel);
//     }
//   })
// }

// 如果存在重复的请求  则取消已发送的请求
// function removePendingRequest(config){
//   const requestKey = generateReqKey(config);
//   if(pendingRequest.has(requestKey)){
//     const cancelToken = pendingRequest.get(requestKey);
//     cancelToken(requestKey);
//     pendingRequest.delete(requestKey);
//   }
// }

// 请求拦截器
instance.interceptors.request.use(
  config => {
    needLoadingRequestCount++

    const token = localStorage.getItem('token')

    if (token) {
      // 注意这里的 'Authorization' 是最标准的请求头字段名
      // 常见格式为 'Bearer ' + token，具体格式请与你的后端开发人员确认！
      config.headers['Authorization'] = token

      // 如果你的后端要求的自定义请求头字段，比如 'X-Token' 或 'token'，则写成：
      // config.headers['X-Token'] = token
    }

    return config
  },

  error => {
    Message({
      type: 'error',
      message: error
    })
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    needLoadingRequestCount--
    const { data } = response
    // Blob 响应直接返回完整 response，供 download 方法使用
    if (data instanceof Blob) {
      return response
    }
    if (!data) {
      // 处理请求空白
      TipMessage('error')
    }
    if (data.state.code !== 200) {
      if (response.config.url !== '/service/download/record/userProgress') {
        TipMessage(data.state.code, data.state.msg)
      }
    }
    // 阶段一改造：响应数据统一转驼峰，递归处理嵌套对象和数组
    return humpObjectDeep(data)

  },
  error => {
    needLoadingRequestCount--
    const { response } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      // userProgress 接口401不触发跳转登录，避免登录后路由守卫中被踢回登录页
      if (response.config.url !== '/service/download/record/userProgress') {
        errorHandle(response.status, response.data.message)
      }
      return Promise.reject(response)
    } else {
      // 处理断网的情况
      // eg:请求超时或断网时，更新state的network状态
      // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
      // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
      if (!window.navigator.onLine) {
        // store.commit('changeNetwork', false);
        Message({
          type: 'error',
          message: $t('integration.network_anomaly')
        })
      }
      if (
        error.code === 'ECONNABORTED' &&
        error.message.indexOf('timeout') !== -1
      ) {
        console.error('请求超时,请求对象:', error.config)
        Message({
          type: 'error',
          message: $t(
            'integration.request_timed_out_c__please_contact_the_administrator'
          )
        })
      } else {
        return Promise.reject(error)
      }
    }
  }
)

// export default axios
export default {
  httpGet ({ url, params }) {
    return new Promise((resolve, reject) => {
      instance
        .get(url, { params })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  exportGet ({ url, params = {} }) {
    return new Promise((resolve, reject) => {
      instance({
        method: 'GET',
        url: url,
        // params: params,
        responseType: 'arraybuffer'
        // responseType: 'blob',
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {})
    })
  },
  /**
   * @post方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  httpPost (url, data) {
    return new Promise((resolve, reject) => {
      instance
        .post(url, data)
        .then(
          res => {
            resolve(res)
          },
          err => {
            reject(err)
          }
        )
        .catch(err => {})
    })
  },
  /**
   * @delete 删除
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  httpdelete (url, data) {
    return new Promise((resolve, reject) => {
      instance({
        url: url,
        method: 'delete',
        params: {
          ...data
        }
      }).then(
        res => {
          resolve(res)
        },
        error => {}
      )
    })
  },
  httpdelete2 (url, data) {
    return new Promise((resolve, reject) => {
      instance({
        url: url,
        method: 'delete',
        data: [...data]
      }).then(
        res => {
          resolve(res)
        },
        error => {}
      )
    })
  },

  /**
   * PUT方法，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  httpPut (url, data) {
    return new Promise((resolve, reject) => {
      instance({
        url: url,
        method: 'put',
        data: {
          ...data
        }
      }).then(
        res => {
          resolve(res)
        },
        error => {}
      )
    })
  },
  httpPut2 (url, data) {
    return new Promise((resolve, reject) => {
      instance({
        url: url,
        method: 'put',
        data: data
      }).then(
        res => {
          resolve(res)
        },
        error => {}
      )
    })
  },

  /**
   * Form请求，对应post请求
   * @param {String} url [请求的url地址]
   * @param {Object} params [请求时携带的参数]
   */
  httpForm (url, data, params) {
    return new Promise((resolve, reject) => {
      instance({
        url,
        method: 'post',
        // 发送的数据
        data: data,
        // url参数
        params,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }).then(res => {
        resolve(res)
      })
    })
  },

  /**
   *
   * @param {*} url 下载URL
   * @param {*} params  下载参数
   * @param {*} fileType  下载文件类型
   */
  download (url, params = {}, fileName = '', fileType = 'xlsx') {

    return new Promise((resolve, reject) => {
      instance({
        method: 'get',
        url,
        params,
        responseType: 'blob'
      })
        .then(r => {
          // 后台能够正常响应流返回
          console.log(r)
          // 判断是否为 JSON 错误响应：
          // 1. 文件下载成功时后端会设置 content-disposition header
          // 2. 文件流的 Content-Type 是 application/zip、application/octet-stream 等具体类型
          // 3. 仅当既没有 content-disposition 且响应类型为 json 时，才当作后台转换失败的错误响应
          const disposition = r.headers['content-disposition']
          const isJsonError = !disposition && r.data.type && r.data.type.indexOf('json') !== -1
          if (!isJsonError) {
            // 文件流：解析文件名并下载
            let fileNames = ''
            if (disposition) {
              fileNames = decodeURIComponent(disposition.split('filename=').pop())
            }
            this.downLoadFn(r, fileType, fileNames)
            resolve(r)
          } else {
            // 说明是普通对象数据，后台转换失败
            const typeCount = { type: 'application/octet-stream' }
            const blob = new Blob([r.data], typeCount)
            const fileReader = new FileReader()
            fileReader.readAsText(blob, 'utf-8')
            fileReader.onload = function () {
              try {
                resolve(JSON.parse(fileReader.result))
              } catch (e) {
                resolve(fileReader.result)
              }
            }
          }
        })
        .catch(r => {
          Message.error(
            $t('integration.a_system_error_occurred_and_the_download_failed')
          )
          reject(r)
        })
    })
  },
  download2 (url, data, fileType = 'xlsx', fileName) {
    return instance
      .post(url, data, { responseType: 'blob' })
      .then(r => {
        this.downLoadFn(r, fileType)
      })
      .catch(r => {
        Message.error(
          $t('integration.a_system_error_occurred_and_the_download_failed')
        )
      })
  },
  downLoadFn (r, fileType, fileName) {
    const contentType = r.headers['responseData-type']
    if (
      contentType !== undefined &&
      contentType.search('application/json') !== -1
    ) {
      //  返回JSON格式说明后台数据有误，提示用户下载文件失败，不执行后面的逻辑
      Message.warning(
        $t(
          'integration.the_file_is_corrupted_dot__please_rebuild_it_and_try_again'
        )
      )
      return
    }
    const responseData = r.data
    // 判断传入的文件格式
    if (fileType === 'xlsx') {
      // if (r.config.url === '/service/sensor/generaUploadTemplateFile') {
      //   this.downloadFile(responseData, `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`, 'SensorUploadTemplate');
      // } else if (r.config.url === '/service/terminal/generaUploadTemplateFile') {
      //   this.downloadFile(responseData, `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`, 'TerminalUploadTemplate');
      // } else if (r.config.url === '/service/gateway/generaUploadTemplateFile') {
      //   this.downloadFile(responseData, `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`, 'GatewayUploadTemplate');
      // } else if (r.config.url === '/service/relay/generaUploadTemplateFile') {
      //   this.downloadFile(responseData, `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`, 'RelayUploadTemplate');
      // }
      // else {
      this.downloadFile(
        responseData,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        fileName || 'GM_' + new Date().getTime()
      )
      // }
    } else if (fileType === 'pdf') {
      this.downloadFile(
        responseData,
        'application/pdf',
        fileName || 'GM_' + new Date().getTime()
      )
    } else {
      this.downloadFile(
        responseData,
        'application/zip',
        fileName || 'GM_' + new Date().getTime()
      )
    }
  },
  /**
   * 下载文件
   * @param data 文件流数据
   * @param contentType MIME文件类型
   * @param fileName  下载文件名称
   * @returns {Blob}  返回Blob对象
   */
  downloadFile (data, contentType, fileName) {
    const blob = new Blob([data], { type: contentType })
    if ('download' in document.createElement('a')) {
      const elementLink = document.createElement('a')
      elementLink.style.display = 'none'
      elementLink.href = URL.createObjectURL(blob)
      elementLink.download = fileName
      document.body.appendChild(elementLink)
      elementLink.click()
      window.URL.revokeObjectURL(elementLink.href)
      document.body.removeChild(elementLink)
      Message.success($t('integration.download_successful'))
    }
    return blob
  },

  // 导出zip=====POST
  exportPost (url, data, isqs = false) {
    Message.warning($t('integration.exporting_data'))
    return new Promise((resolve, reject) => {
      return instance({
        method: 'POST',
        url: url,
        data: { ...data },
        responseType: 'blob',
        headers: { 'content-type': 'application/json; charset=utf-8' }
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/zip' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a') // 创建a标签
          link.href = url
          link.download = '' // 重命名文件
          link.click()
          Message.success($t('integration.export_succeeded'))
          document.body.removeChild(link)
          URL.revokeObjectURL(url) // 释放内存
          resolve()
        })
        .catch(error => {
          resolve(error)
        })
    })
  },
  // 导出GET
  exportPostGet (url, params, method, filename) {
    return new Promise((resove, reject) => {
      return instance({
        url: url.url,
        method: 'GET',
        params: url.params,
        headers: {
          'content-type': 'application/json; charset=utf-8'
        },
        responseType: 'blob'
      })
        .then(response => {
          const blob = new Blob([response.data], { type: 'application/zip' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a') // 创建a标签
          link.href = url
          link.download = '' // 重命名文件
          link.click()
          Message.success($t('integration.export_succeeded'))
          document.body.removeChild(link)
          URL.revokeObjectURL(url) // 释放内存
        })
        .catch(error => {
          resove(error)
        })
    })
  }
}
